import {observable, action, computed} from 'mobx';

import {ERROR_STATES} from './constants';
import {MarketoValidator} from './validators';

type MarketoFieldValue = string | boolean | null;

export class MarketoField {
    @observable value: MarketoFieldValue = null;
    @observable.shallow validators: MarketoValidator[] = [];

    constructor(
        public label: string,
        public mktoName: string,
        public inputProps = {},
        public optional = false,
    ) {}

    @action
    addValidator(validator: MarketoValidator) {
        this.validators.push(validator);
    }

    @action
    updateValue(value: MarketoFieldValue) {
        this.value = value;
    }

    @computed
    get validationState() {
        // Untouched
        if (this.value === null || this.optional) {
            return ERROR_STATES.NEUTRAL;
        }

        const [invalid] = this.error;
        if (invalid) {
            return ERROR_STATES.ERROR;
        }

        return ERROR_STATES.NEUTRAL;
    }

    @computed
    get error() {
        if (!this.validators.length) {
            // If there is no validator just validate for empty
            return (typeof this.value === 'string' ? this.value : '').trim()
                ? [false]
                : [true, gettext('This field is required')];
        }

        for (const validator of this.validators) {
            if (!validator.validate(typeof this.value === 'string' ? this.value : '')) {
                return [true, validator.errorMessage];
            }
        }

        return [false];
    }

    @computed
    get errorMessage() {
        const [invalid, errorMessage] = this.error;
        if (this.validationState !== ERROR_STATES.ERROR || !invalid) {
            return null;
        }
        return errorMessage;
    }
}
